export const acknowledgment = [
  {
    title: "Application for Bachelor of Pharmacy study program Academic Year 2026/2027",
    arabicTitle: "طلب التحاق في برنامج بكالوريوس الصيدلة (للدارسين على حسابهم الخاص فقط)",
    text: `Admission to the Bachelor of Pharmacy program for the academic year 2026/2027 is competitive and according to the college capacity and the availability of seats. Meeting the minimum requirements or submitting the required documents does not mean acceptance or admission to the university.`,
    termsAndConditions: [
      {
        title: "Minimum Admission Requirements for Self Sponsor Students",
        conditions: [
          {
            text: `1. Academic Qualifications:
            • A minimum 90% general secondary school average (scientific stream) or its equivalent in the State of Kuwait and recognized by the American University of Medical Sciences.
            • Conditional Admission: Students scoring 80–89% general secondary school average (scientific stream) may be admitted on probation, provided they pass all first-year courses during their academic enrollment.`
          },
          {
            text: `2. English Language Proficiency test with a minimum score of 80% or minimum IELTS 5.5 score or its equivalent (dated within the last two years).
            • Conditional Admission: Students scoring below the minimum English proficiency requirements must enroll in and pass English Language Elective courses during their first year, based on their scores.`
          },
          {
            text: `3. Personal Interview: Applicants must pass the university’s personal interview.`
          },
          {
            text: `4. Submission of Required Documents: All required documents must be submitted to the university administration by the specified deadline.`
          },
          {
            text: `5. Fees Payment: Applicants must pay the non-refundable application fees to be considered for admission.`
          }
        ]
      }
    ],
    admissionValidity: "Admission is valid only for the semester in which the student has been accepted.",
    requiredDoc: [
      {
        title: "Required Documents for Admission (Upload) All in PDF Format:",
        conditions: [
          { text: "1. Official grade transcript or certified copy (High School Certificate)." },
          { text: "2. Equivalency of high school degree issued by the Ministry of Education in Kuwait (for private school graduates)." },
          { text: "3. Valid IELTS score report (no older than two years)." },
          { text: "4. Copy of birth certificate." },
          { text: "5. Valid National ID (no less than 3 months validity) and valid passport photocopies." },
          { text: "6. Valid Security Cards (for non-Kuwaitis only)." },
          { text: "7. Passport-sized photographs." },
          { text: "8. Valid National ID and valid passport photocopies of parents / or legal guardian." },
          { text: "9. Kuwaiti Applicants: Sahel App (Certificate proof of citizenship of father)." }
        ],
        subtitle: "Additional documents may be required for admission to the College of Pharmacy."
      }
    ],
    notes: [
      {
        title: "Note",
        points: [
          {
            text: `Admission is extremely competitive and is based on the strength of the applicant pool and the available capacity.`
          },
          {
            text: `Note that fulfilling the requirements and admission conditions does not mean acceptance into the university.`
          }
        ]
      }
    ]
  }
];
